import React, { useState } from 'react';
import { Tabs, Card, Typography } from 'antd';
import { TeamOutlined, BarChartOutlined, UserOutlined } from '@ant-design/icons';

// Import main components
import ManageCoaches from './ManageCoaches/ManageCoaches';
import PerformanceAnalytics from './PerformanceAnalytics/PerformanceAnalytics';
import CoachDetails from './CoachDetails/CoachDetails';

// Export individual components for direct imports
export { default as ManageCoaches } from './ManageCoaches/ManageCoaches';
export { default as PerformanceAnalytics } from './PerformanceAnalytics/PerformanceAnalytics';
export { default as CoachDetails } from './CoachDetails/CoachDetails';

// Export shared components
export { default as CoachCard } from './components/shared/CoachCard';
export { default as CoachStatsCard } from './components/shared/CoachStatsCard';
export { default as CoachTable } from './components/shared/CoachTable';

// Export types, constants, and utilities
export * from './types';
export * from './constants';
export { 
  formatFullName, 
  formatPhoneNumber, 
  formatCurrency, 
  getRatingColor, 
  getRatingLabel 
} from './utils/coachUtils';

const { Title } = Typography;

const CoachesRouter: React.FC = () => {
  const [activeTab, setActiveTab] = useState<string>('manage');

  const tabItems = [
    {
      key: 'manage',
      label: (
        <span>
          <TeamOutlined />
          Manage Coaches
        </span>
      ),
      children: <ManageCoaches />,
    },
    {
      key: 'analytics',
      label: (
        <span>
          <BarChartOutlined />
          Performance Analytics
        </span>
      ),
      children: <PerformanceAnalytics />,
    },
    {
      key: 'details',
      label: (
        <span>
          <UserOutlined />
          Coach Details
        </span>
      ),
      children: <CoachDetails />,
    },
  ];

  return (
    <div>
      <Card style={{ marginBottom: 24 }}>
        <Title level={2} style={{ margin: 0 }}>
          <TeamOutlined /> Coaches Management
        </Title>
        <Typography.Text type="secondary">
          Comprehensive coach management, analytics, and performance tracking
        </Typography.Text>
      </Card>

      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        type="card"
        items={tabItems}
      />
    </div>
  );
};

export default CoachesRouter; 